<div class="payment-form">
  <h2 class="section-title ks-p-3">Card information</h2>

  <div class="error-message" *ngIf="validationMessage" hidden>{{ validationMessage }}</div>

  <div class="form-group">
    <label>Name on Card</label>
    <div id="cardNameElement" class="bt-element"></div>
    <div *ngIf="cardNameEmpty" class="error-message">Card Name is required</div>
  </div>

  <div class="form-group">
    <label class="alias-label">Alias</label>
    <!-- Use a regular input or a Basis Theory text element for the alias -->
    <input
      type="text"
      id="aliasInput"
      [(ngModel)]="aliasValue"
      class="form-control alias-element"
    />
    <div *ngIf="aliasEmpty" class="error-message">Alias is required</div>
  </div>

  <div class="form-group">
    <label>Card Number</label>
    <div id="cardNumberElement" class="bt-element"></div>
    <div *ngIf="cardNumberEmpty" class="error-message">Card Number is required</div>
  </div>

  <div class="row ks-m-0">
    <div class="form-group half-width">
      <label>Expiration Date</label>
      <div id="cardExpirationDateElement" class="bt-element"></div>
      <div *ngIf="expirationDateEmpty" class="error-message">Expiration Date is required</div>
    </div>

    <div class="form-group half-width">
      <label>CVC/CVV</label>
      <div id="cardVerificationCodeElement" class="bt-element"></div>
      <div *ngIf="cvcEmpty" class="error-message">CVC is required</div>
    </div>
  </div>

  <div class="form-group">
    <label>Zip Code</label>
    <div id="zipCodeElement" class="bt-element"></div>
  </div>

  <div *ngIf="showSavePaymentMethodOption" class="form-group">
    <div class="d-flex align-items-center">
      <mat-slide-toggle [(ngModel)]="savePaymentMethod"></mat-slide-toggle>
      <mat-label class="payment-saved"> Save Payment Method </mat-label>
    </div>
  </div>

  <button
    type="button"
    class="ks-btn-md ks-btn-primary add-payment-method-button"
    (click)="onSubmit()"
    *ngIf="showSubmitButton"
    [disabled]="isSubmitting"
  >
    <span
      inlineSVG="assets/media/svg/icons/General/white-wallet.svg"
      class="ks-mr-2 svg-icon-md"
    ></span>
    {{ isSubmitting ? 'Processing...' : 'Add card to wallet' }}
  </button>
</div>
